import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: [],
    loading: false,
    error: null
};

const employeeSlice = createSlice({
    name: "employee",

    initialState,

    reducers: {
        setValue: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});
export const { setLoading, setValue } = employeeSlice.actions;
export default employeeSlice.reducer;
